var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vs-popup",
    {
      attrs: { active: _vm.isActive, title: "" },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
        close: _vm.close,
      },
    },
    [
      _vm.comment
        ? _c("div", { staticClass: "comment-modal-popup" }, [
            _c("div", { staticClass: "comment-modal-body" }, [
              _c(
                "div",
                { staticClass: "comment-modal-icon" },
                [
                  _c("feather-icon", {
                    attrs: {
                      icon: "MessageSquareIcon",
                      svgClasses: "w-6 h-6 text-primary",
                    },
                  }),
                ],
                1
              ),
              _c("h3", { staticClass: "comment-modal-title" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _c("div", { staticClass: "comment-modal-content" }, [
                _c("p", { staticClass: "comment-text-full" }, [
                  _vm._v(_vm._s(_vm.comment)),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "comment-modal-actions" },
                [
                  _c(
                    "vs-button",
                    { attrs: { color: "primary" }, on: { click: _vm.close } },
                    [_vm._v("Cerrar")]
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }